import React from 'react';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import { MultiLanguageEditor } from '../others/MultiLanguageEditor';
import { useTranslation } from 'react-i18next';

export const DetailsExecutionLog = ({ open, data, setOpen }) => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <Dialog
                open={open}
                fullWidth
                maxWidth='lg'
            >
                <DialogTitle>
                    <Typography variant='h5' component='h5'>
                        {t("responseDetails")}
                    </Typography>
                    <IconButton
                        aria-label='close'
                        onClick={() => setOpen(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <MultiLanguageEditor
                        value={data}
                        dfLanguage={'json'}
                        errorInputs={{}}
                        field={{
                            id: "response",
                            label: "Response:"
                        }}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}